import React, { useState } from 'react';
import './auth.css';
import { ToastContainer, toast } from 'react-toastify';
import Loading from './loaders/Loading';
import Message from './loaders/Message';
import HomeToastNotification from './loaders/HomeToastNotification';
import WhatsAppFloat from './WhatsAppFloat';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [toastNotification, setToastNotification] = useState(null);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('');

    try {
      const response = await fetch('https://api.visiontech2030.com/register/password-reset-request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const responseText = await response.text();

      if (response.ok) {
        setMessage('Password reset link sent! Please check your email.');
        setMessageType('success');
        setEmail('');
        toast.success('Password reset instructions sent to your email!');
      } else {
        setMessage(responseText || 'Failed to send password reset link.');
        setMessageType('error');
        toast.error(responseText || 'Failed to send password reset link.');
      }
    } catch (error) {
      const errorMessage = 'Network error. Please try again later.';
      setMessage(errorMessage);
      setMessageType('error');
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const contactAdmin = () => {
    setToastNotification({ message: 'Please Contact Admin For Password Reset.', type: 'success' });
  };

  return (
    <div className="auth-container">
      {loading && <Loading />}
      <div className="auth-wrapper">
        <h2>Reset Your Password</h2>
        {message && <Message type={messageType} message={message} />}
        <p className="auth-description">
          Enter your email address below and we'll send you instructions to reset your password. <strong>Or Contact Admin for password Reset.</strong>
        </p>
        <form className="auth-form" onSubmit={contactAdmin}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              className="form-control"
              placeholder="Enter your registered email"
              value={email}
              onChange={handleEmailChange}
              required
            />
          </div>
          <button 
            type="submit" 
            className="btn-auth"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
      </div>
      <ToastContainer position="top-right" autoClose={5000} />
      {toastNotification && (
         <HomeToastNotification
           message={toastNotification.message}
           type={toastNotification.type}
           onClose={() => setToastNotification(null)}
         />
       )}
       <WhatsAppFloat />
    </div>
  );
};

export default ForgotPassword;